import { render, staticRenderFns } from "./RequestCard.vue?vue&type=template&id=fceb78e0&"
import script from "./RequestCard.vue?vue&type=script&lang=js&"
export * from "./RequestCard.vue?vue&type=script&lang=js&"
import style0 from "./RequestCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports